import { DRAFT, ENDED_LEASE, EXPRIED, FUTURE, LEASED, MONTH_TO_MONTH, UNKNOWN } from '~/assets/strings';
import { LeaseStatus } from '~/types/Lease';
import { LeaseRenewalStatus } from '~/types/LeaseRenewals';
import { MaintenanceRequestStatus } from '~/types/MaintenanceRequestStatus';
import { MoveOutRequestStatus } from '~/types/MoveOutRequest';
export const getStatusColor = (status: MaintenanceRequestStatus | undefined): string => {
  switch (status) {
    case MaintenanceRequestStatus.WorkOrder:
      return 'bg-[#EAF3FF] text-[#0065FF]';
    case MaintenanceRequestStatus.InProgress:
      return 'bg-[#CDF0E6] text-[#009374]';
    case MaintenanceRequestStatus.Closed:
      return 'bg-[#E5EDF8] text-[#6C80AF]';
    case MaintenanceRequestStatus.Pending:
      return 'bg-[#FFF4D7] text-label-orange';
    case MaintenanceRequestStatus.Processing:
      return 'bg-[#437AFF] text-white';
    case MaintenanceRequestStatus.Cancelled:
      return 'bg-red-100 text-danger';
    case MaintenanceRequestStatus.OnHold:
      return 'bg-warning-light';
    default:
      return 'bg-gray-200';
  }
};

export const getRenewalStatusColor = (status: LeaseRenewalStatus | undefined): string => {
  switch (status) {
    case LeaseRenewalStatus.Finalized:
      return 'bg-[#EAF3FF] text-[#0065FF]';
    case LeaseRenewalStatus.Offered:
      return 'bg-[#CDF0E6] text-[#009374]';
    case LeaseRenewalStatus.Rejected:
      return 'bg-red-100 text-danger';
    case LeaseRenewalStatus.Retracted:
      return 'bg-[#437AFF] text-white';
    case LeaseRenewalStatus.Signing:
      return 'bg-[#FFF4D7] text-label-orange';
    default:
      return 'bg-gray-200';
  }
};

export const getRenewalStatusBgColor = (status: LeaseRenewalStatus | undefined): string => {
  switch (status) {
    case LeaseRenewalStatus.Finalized:
      return 'bg-[#0065FF]';
    case LeaseRenewalStatus.Offered:
      return 'bg-[#009374]';
    case LeaseRenewalStatus.Rejected:
      return 'bg-danger';
    case LeaseRenewalStatus.Retracted:
      return 'bg-white';
    case LeaseRenewalStatus.Signing:
      return 'bg-label-orange';
    default:
      return 'bg-gray-200';
  }
};

export const getLeaseStatusText = (status?: LeaseStatus): string => {
  switch (status) {
    case LeaseStatus.Lease:
    case LeaseStatus.LeaseMonthToMonth:
    case LeaseStatus.Eviction:
      return LEASED;
    case LeaseStatus.MonthToMonth:
      return MONTH_TO_MONTH;
    case LeaseStatus.Expired:
      return EXPRIED;
    case LeaseStatus.Draft:
      return DRAFT;
    case LeaseStatus.Ended:
      return ENDED_LEASE;
    case LeaseStatus.Future:
      return FUTURE;
  }
  return UNKNOWN;
};

export const getLeaseStatusColor = (status?: LeaseStatus): string => {
  switch (status) {
    case LeaseStatus.Lease:
    case LeaseStatus.LeaseMonthToMonth:
    case LeaseStatus.Eviction:
      return '#36cbac';
    case LeaseStatus.MonthToMonth:
      return '#fa8511';
    case LeaseStatus.Expired:
      return '#ec00d4';
    case LeaseStatus.Draft:
      return '#a126ec';
    default:
      return '#333851';
  }
};

export const getMoveOutRequestStatusColor = (status: MoveOutRequestStatus): string => {
  switch (status) {
    case MoveOutRequestStatus.Requested:
      return 'bg-label-orange text-white';
    case MoveOutRequestStatus.Approved:
      return 'bg-[#009374] text-white';
    case MoveOutRequestStatus.Rejected:
      return 'bg-danger text-white';
    case MoveOutRequestStatus.Retracted:
      return 'bg-gray-400 text-white';
    default:
      return 'bg-gray-200 text-white';
  }
};
